import React from 'react';
import { Link } from 'react-router-dom';
import Heading from '../../components/common/Typography/Heading';
import Paragraph from '../../components/common/Typography/Paragraph';
import ButtonText from '../../components/common/Typography/ButtonText';
import {
  PUBLIC_ABOUT_COLUMN_GAP_CLASS,
  PUBLIC_BODY_TO_LINK_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from '../Public/shared/publicLayoutSpec';

const WhoWeBuiltFor = () => {
  return (
    <section className={PUBLIC_SECTION_GAP_CLASS}>
      <div className="tp-container-main mx-auto px-10">
        <div className={`flex flex-col lg:flex-row ${PUBLIC_ABOUT_COLUMN_GAP_CLASS} items-start`}>
          {/* Left Column - Heading (55%) */}
          <div className="lg:w-[52%] lg:sticky lg:top-8">
            <Heading variant="h2" className="font-extrabold text-offblack">
              Who We <br />Built It For
            </Heading>
          </div>
          
          {/* Middle Column - For Customers (22.5%) */}
          <div className={`lg:w-[24%] space-y-5 ${PUBLIC_HEADING_TO_CONTENT_CLASS} lg:mt-0`}>
            <Heading variant="h4" className="text-offblack font-bold">
              For Customers
            </Heading>
            <Paragraph variant="MainParagraph" className="text-offblack">
              Trades Poster makes it easier for everyday Australians to find licensed, qualified, and verified trades. You can view full business profiles, contact tradies directly, and request quotes when you're ready — no filtered messaging, no middlemen. Every business is reviewed before going live, and we're working to improve checks over time.
            </Paragraph>
            <Link to="/customer-support-centre">
                <ButtonText variant={"SecondaryText"} className={`${PUBLIC_BODY_TO_LINK_CLASS} hover:text-primaryblue`}>
                    Learn More
                </ButtonText>
            </Link>
          </div>
          
          {/* Right Column - For Businesses (22.5%) */}
          <div className={`lg:w-[24%] space-y-5 ${PUBLIC_HEADING_TO_CONTENT_CLASS} lg:mt-0`}>
            <Heading variant="h4" className="text-offblack font-bold">
              For Businesses
            </Heading>
            <Paragraph variant="MainParagraph" className="text-offblack">
              This platform is designed to help real trade businesses grow — without bidding, commission cuts, or hidden charges. You can post services, receive quote requests, and display your licence, reviews, and contact info openly. No interference. You set the terms. You deal with customers directly.
            </Paragraph>
            <Link to="/business-support-centre">
                <ButtonText variant={"SecondaryText"} className={`${PUBLIC_BODY_TO_LINK_CLASS} hover:text-primaryblue`}>
                    Learn More
                </ButtonText>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeBuiltFor;